export default (
    component,
    {
        showAllEntangle = 'showAll',
        expandedEntangle = null,
        editModeId = null,
        editModeEntangle = null,
        editModeDefaultValue = null,
        editModeWatchCallback = null,
        createModeEntangle = null,
        createModeDefaultValue = false,
        createModeWatchCallback = null,
    } = {}
) => ({
    showAll: showAllEntangle ? component.entangle(showAllEntangle).live : null,
    expanded: null,
    expandedEntangle: expandedEntangle,

    editMode: editModeEntangle,
    createMode: createModeEntangle,

    _listeners: {},

    init() {
        const componentId = component.__instance.id;

        this._listeners.closeExpanded = () => this.expanded = false;
        window.addEventListener(`close-expanded::${componentId}`, this._listeners.closeExpanded);

        // Reset state when route changes (listens to Livewire browser event)
        this._listeners.routeChanged = () => {
            // Use $nextTick to ensure DOM is updated before resetting state
            this.$nextTick(() => {
                this.expanded = null;
                this.editMode = editModeDefaultValue;
                this.createMode = createModeDefaultValue;
            });
        };
        window.addEventListener('art-sets::route-changed', this._listeners.routeChanged);

        if (!editModeId) {
            return
        }

        this._listeners.setExpanded = ({ detail }) => this.expanded = detail;
        this._listeners.closeEdit = () => this.editMode = editModeDefaultValue;
        this._listeners.closeCreate = () => this.createMode = createModeDefaultValue;

        window.addEventListener(`set-expanded::${editModeId}`, this._listeners.setExpanded);
        window.addEventListener(`close-edit::${editModeId}`, this._listeners.closeEdit);
        window.addEventListener(`close-create::${editModeId}`, this._listeners.closeCreate);

        this.$watch('editMode', (value) => {
            if (editModeWatchCallback) {
                editModeWatchCallback(this)
            }

            if (value) {
                if (value !== this.expanded) {
                    this.expanded = null;
                }

                this.$store.editMode.edit(`info-${editModeId}`);
            } else {
                this.$dispatch('editMode::reset');
            }
        })

        this.$watch('createMode', (value) => {
            if (createModeWatchCallback) {
                createModeWatchCallback(this)
            }

            if (value) {
                this.expanded = null
                this.$store.editMode.edit(`create-${editModeId}`);
            } else {
                this.$dispatch('editMode::reset');
            }
        })
    },

    destroy() {
        const componentId = component.__instance?.id;

        if (this._listeners.closeExpanded && componentId) {
            window.removeEventListener(`close-expanded::${componentId}`, this._listeners.closeExpanded);
        }
        if (this._listeners.routeChanged) {
            window.removeEventListener('art-sets::route-changed', this._listeners.routeChanged);
        }
        if (editModeId) {
            if (this._listeners.setExpanded) {
                window.removeEventListener(`set-expanded::${editModeId}`, this._listeners.setExpanded);
            }
            if (this._listeners.closeEdit) {
                window.removeEventListener(`close-edit::${editModeId}`, this._listeners.closeEdit);
            }
            if (this._listeners.closeCreate) {
                window.removeEventListener(`close-create::${editModeId}`, this._listeners.closeCreate);
            }
        }
        this._listeners = {};
    },

    expand: function (item) {
        if (this.expanded == item) {
            this.expanded = null
        } else {
            this.expanded = item
            this.expandedEntangle = item;
        }

        let componentName = component.__instance.name;
        componentName = componentName.replace(/\./g, "-")

        this.$dispatch(`flex-table-expand-changed:${componentName}`)
    },

    toggleShowAll: function () {
        this.showAll = !this.showAll
        this.expanded = null
    },

    selectRow: function (element, event) {
        if (event.target.tagName.toLowerCase() === 'input' || element.querySelector('[data-row-actions]').contains(event.target)) {
            event.stopPropagation();
        } else {
            element.querySelector('input').click();
        }
    },
})
